module.exports = __webpack_public_path__ + "static/logo-76e5a48a8759fe604cf316fb0ba461fb.svg";